import { cn } from '#lib/utils'

// The brand name is read from here only (`DESIGN.md`, section 6): a rename is a
// change to these two lines, not a search through the apps.
export const BRAND_LEAD = 'Uni'
export const BRAND_TAIL = 'casa'
export const BRAND_NAME = `${BRAND_LEAD}${BRAND_TAIL}`

/**
 * The brand as a word: "Uni" in bold foreground, "casa" in medium muted,
 * slightly tight. The symbol is `MarchioSimbolo`.
 */
export function Marchio({
	className,
	tailClassName
}: {
	className?: string
	/** Classes for "casa" alone, for example to hide it in a narrow space. */
	tailClassName?: string
}) {
	return (
		<span
			className={cn('inline-flex select-none tracking-tight', className)}
		>
			<span className='sr-only'>{BRAND_NAME}</span>
			<span aria-hidden='true' className='font-bold text-foreground'>
				{BRAND_LEAD}
			</span>
			<span
				aria-hidden='true'
				className={cn(
					'font-medium text-muted-foreground',
					tailClassName
				)}
			>
				{BRAND_TAIL}
			</span>
		</span>
	)
}

/**
 * The symbol of the brand: a house under a graduation cap on a rounded square,
 * drawn with the theme tokens so it follows the palette. Decorative: the name
 * next to it, or the label of the link around it, says what it is.
 */
export function MarchioSimbolo({ className }: { className?: string }) {
	return (
		<svg
			aria-hidden='true'
			className={cn('size-8', className)}
			viewBox='0 0 40 40'
		>
			<rect fill='var(--primary)' height='40' rx='10' width='40' />
			<path
				d='M20 7.5 33 13.2 20 18.9 7 13.2Z'
				fill='var(--primary-foreground)'
			/>
			<path
				d='M30.2 14.4v5.4'
				stroke='var(--chart-1)'
				strokeLinecap='round'
				strokeWidth='1.6'
			/>
			<circle cx='30.2' cy='21' fill='var(--chart-1)' r='1.6' />
			<path
				d='M11.5 17.2V31a1.5 1.5 0 0 0 1.5 1.5h14A1.5 1.5 0 0 0 28.5 31V17.2'
				fill='none'
				stroke='var(--primary-foreground)'
				strokeLinejoin='round'
				strokeWidth='2.2'
			/>
			<path
				d='M17 32.5v-5a3 3 0 0 1 6 0v5'
				fill='none'
				stroke='var(--primary-foreground)'
				strokeLinecap='round'
				strokeWidth='2.2'
			/>
		</svg>
	)
}
